import "./styles.css";
import { Header } from "../header-new/header";
import equi from "../../asset-source/equi.png";
import equi1 from "../../asset-source/equi1.png";
import defieq from "../../asset-source/defieq.jpg";
import outstands from "../../asset-source/equilibrium-wjet-outstands-4.jpg";
import research from "../../asset-source/equilibrium-wjet-research-5.jpg";
import usecases from "../../asset-source/equilibrium-wjet-use-cases-6.png";
import testa from "../../asset-source/equilibrium-wjet-test-A-6-1.jpg";
import testb from "../../asset-source/equilibrium-wjet-test-B-6-2.jpg";
import calcs from "../../asset-source/equilibrium-wjet-stake-calculator-7-3.png";
import visuals from "../../asset-source/equilibrium-wjet-visuals-8.png";
import polkadot from "../../asset-source/equilibrium-wjet-polkadot-9-1.jpg";
import utility from "../../asset-source/equilibrium-wjet-eq-utility-9-2.jpg";
import screens from "../../asset-source/equilibrium-wjet-mobile-screens-10.png";
import { useState } from "react";
import { Footer } from "../footer/footer";

import ContactUsModal from "../modal/contact-us";
import { useNavigate } from "react-router-dom";

function EquiPage() {
	const navigate = useNavigate();

	document.title =
		"Продуктовая страница Equilibrium – дизайн, который работает";
	document.getElementsByTagName("META")[2].content =
		"Продуктовая страница Equilibrium. Как мы создали удобный и эффективный дизайн продуктовой страницы для криптовалютного проекта.";

	document.getElementsByTagName("META")[3].content =
		"UX/UI дизайн для криптовалютных проектов, разработка дизайна для блокчейн-платформ, создание продуктовых страниц, дизайн интерфейсов для DeFi, дизайн цифровых продуктов, UX/UI для криптовалютных платформ, UX/UI дизайн студия, дизайн для цифрового бизнеса, проектирование пользовательских интерфейсов, разработка дизайна для цифровых продуктов, профессиональный дизайн для крипто-стартапов";

	return (
		<div className="equi">
			<div className="wrapper gradiented">
				<Header onLight={false} />

				<div className="container">
					<a href="/" className="allProjectLink">
						<svg
							width="17"
							height="16"
							viewBox="0 0 17 16"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								id="Arrow 4"
								d="M0.292892 8.70711C-0.0976315 8.31658 -0.0976315 7.68342 0.292892 7.29289L6.65685 0.928932C7.04738 0.538408 7.68054 0.538408 8.07107 0.928932C8.46159 1.31946 8.46159 1.95262 8.07107 2.34315L2.41421 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292892 8.70711ZM17 9H1V7H17V9Z"
								fill="currentColor"
							/>
						</svg>
						Все проекты
					</a>

					<div className="titleBlock">
						<h1 className="h1" style={{ textAlign: "center" }}>
							Продуктовые страницы
							<br />
							<span style={{ color: "rgba(32, 139, 248, 1)" }}>
								Equilibrium
							</span>{" "}
						</h1>
						<div className="mainpagerow">
							<div className="mainrowitem">Продуктовая страница DeFi</div>
							<div className="mainrowitem">Калькуляторы стейкинга</div>
							<div className="mainrowitem">Страница токена</div>
							<div className="mainrowitem">Стратегии заработка</div>
						</div>
					</div>

					<img
						src={equi}
						alt="Прототип продуктовой страницы для криптовалютного проекта"
						className="picture"
					/>
				</div>
			</div>

			<div className="feature__wrapper">
				<div className="container">
					<div className="containersm">
						<div className="about__title">
							<h2 className="about__titlerow">
								Создание продуктовой страницы Equilibrium от идеи до результата
							</h2>
						</div>

						<div className="about__features">
							<div className="about__featureunit">
								<div>Компания</div>
								<div className="about__featurevalue">Equilibrium</div>
							</div>

							<div className="about__featureunit">
								<div>Индустрия</div>
								<div className="about__featurevalue">
									Blockchain, DeFi, Crypto
								</div>
							</div>

							<div className="about__featureunit">
								<div>Релиз</div>
								<div className="about__featurevalue">2022</div>
							</div>

							<div className="about__featureunit">
								<div>Cсылка</div>
								<a
									href="https://equilibrium.io"
									target="_blank"
									className="about__featurevalue"
									rel="noreferrer"
								>
									equilibrium.io
								</a>
							</div>
						</div>

						<div className="abouts">
							<div className="aboutstitle">О&nbsp;проекте</div>
							<div className="about__hatinfo">
								Equilibrium&nbsp;— это&nbsp;децентрализованная платформа
								финансовых инструментов, работающая на&nbsp;блокчейне Polkadot.
								Проект предоставляет полный набор DeFi-сервисов, включая
								кредитование, стейкинг и&nbsp;управление активами, обеспечивая
								пользователям доступ к&nbsp;прозрачным и&nbsp;безопасным
								финансовым решениям без&nbsp;посредников.
							</div>
						</div>

						<div className="abouts">
							<div className="aboutstitle">Задача</div>
							<div className="about__hatinfo">
								Создать продуктовую страницу для&nbsp;Equilibrium, которая
								понятно и&nbsp;ярко покажет ключевые возможности платформы,
								её&nbsp;преимущества и&nbsp;ценность для&nbsp;пользователей.
								Страница должна быть удобной, привлекательной и&nbsp;подходить
								для&nbsp;продвижения продукта.
							</div>
						</div>

						<div className="abouts">
							<div className="aboutstitle">Решение</div>
							<div className="about__hatinfo">
								Мы&nbsp;разработали продуктовую страницу, которая ясно
								демонстрирует преимущества платформы Equilibrium, эффективно
								привлекает и&nbsp;обучает пользователей. Решение полностью
								соответствует задачам бизнеса и&nbsp;показывает конверсию выше
								среднего уровня на&nbsp;рынке.
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="feature__wrapper equi__colored">
				<div className="container">
					<div className="containersm">
						<div className="about__title">
							<h2 className="about__titlerow">
								Принципы, на&nbsp;которые мы&nbsp;опирались при&nbsp;анализе
								и&nbsp;разработке дизайна продуктовой страницы{" "}
							</h2>
						</div>

						<div className="about__hatinfo">
							Прежде всего были сформулированы основные принципы,
							на&nbsp;которых строилась вся&nbsp;работа над&nbsp;продуктовой
							страницей Equilibrium, от&nbsp;анализа рынка и&nbsp;конкурентов
							до&nbsp;создания дизайна.
						</div>

						<div className="numlist">
							<div className="numlistUnit">
								<div className="numlistNum">1.</div>
								<div>
									Продукт продают его&nbsp;ключевые особенности
									и&nbsp;преимущества&nbsp;— делаем акцент на&nbsp;том,
									что&nbsp;важно для&nbsp;пользователя.
								</div>
							</div>

							<div className="numlistUnit">
								<div className="numlistNum">2.</div>
								<div>
									Продукт нужно показать, а&nbsp;не&nbsp;скрыть&nbsp;—
									используем визуализацию и&nbsp;чёткое представление
									возможностей.
								</div>
							</div>

							<div className="numlistUnit">
								<div className="numlistNum">3.</div>
								<div>
									Фокусировка&nbsp;— выделяем главное, убираем всё,
									что&nbsp;может отвлекать.
								</div>
							</div>

							<div className="numlistUnit">
								<div className="numlistNum">4.</div>
								<div>Скорость разработки.</div>
							</div>

							<div className="numlistUnit">
								<div className="numlistNum">5.</div>
								<div>
									Масштабируемость для&nbsp;маркетинга и&nbsp;продвижения.
								</div>
							</div>

							<div className="numlistUnit">
								<div className="numlistNum">6.</div>
								<div>
									Дизайн с&nbsp;фокусом на&nbsp;3С: Contrast, Colorful, Clearlу,
									или&nbsp;Контрастно, Ярко, Ясно.
								</div>
							</div>
						</div>
					</div>
					<img
						src={equi1}
						alt="3D графика на продуктовой странице криптовалютной платформы"
						className="about__widepic"
					/>
					<div style={{ marginTop: 24 }}>*Контрастно, Ярко, Ясно</div>
				</div>
			</div>

			<div className="feature__wrapper gradiented">
				<div className="container">
					<div className="containersm">
						<div className="about__title">
							<div>
								<h2 className="about__titlerow">
									Ключевые особенности и акценты продуктовой страницы
								</h2>

								<div className="about__hatinfo hatinfo__hatfix">
									Продуктовая страница Equilibrium помогает новым пользователям
									разобраться в&nbsp;сложной теме децентрализованных финансов.
									Используя простой язык и&nbsp;удобную визуализацию,
									мы&nbsp;сделали акцент на&nbsp;том, чтобы&nbsp;подать
									информацию понятно даже&nbsp;для&nbsp;тех, кто&nbsp;впервые
									сталкивается с&nbsp;криптоинструментами.
								</div>
							</div>
						</div>

						<div className="abouts">
							<h3 className="aboutstitle">
								Уникальные преимущества платформы Equilibrium
							</h3>
							<div className="about__hatinfo">
								Мы&nbsp;создали продуктовую страницу, которая чётко выделяет
								основные функции платформы, такие как&nbsp;
								<b>
									Money Market, EQD Stablecoin, Spot Market, Earn Pools
								</b>{" "}
								и&nbsp;<b>eqDOT</b>. Каждый инструмент представлен
								в&nbsp;отдельном визуальном блоке с&nbsp;кратким описанием
								и&nbsp;яркими графическими элементами, чтобы&nbsp;привлечь
								внимание и&nbsp;быстро донести ценность до&nbsp;пользователя.
								При&nbsp;этом блок <b>Money Market</b> выделен ярче,
								чтобы&nbsp;подчеркнуть его&nbsp;значимость
								для&nbsp;пользователя. Структура страницы выстроена логично
								и&nbsp;с&nbsp;учётом пути пользователя: от&nbsp;знакомства
								с&nbsp;ключевыми функциями платформы до&nbsp;более детального
								раскрытия их&nbsp;преимуществ.
							</div>
						</div>

						<img
							src={defieq}
							alt="Процесс разработки дизайна для криптовалютного проекта"
							className="about__widepic"
						/>

						<div className="abouts">
							<h3 className="aboutstitle">
								Дизайн продуктовой страницы Equilibrium с&nbsp;акцентом
								на&nbsp;ключевых инструментах
							</h3>
							<div className="about__hatinfo">
								Мы сделали акцент на ключевых преимуществах Equilibrium, которые
								подчеркивают её ценность для пользователей:
							</div>

							<div className="numlist">
								<div className="numlistUnit">
									<div className="numlistNum">1.</div>
									<div>
										<b>Лучший пользовательский опыт</b> &mdash; единая платформа
										с простым и удобным интерфейсом, объединяющая все
										DeFi-сервисы.
									</div>
								</div>

								<div className="numlistUnit">
									<div className="numlistNum">2.</div>
									<div>
										<b>Повышенная устойчивость</b> &mdash; все кредиты
										предварительно обеспечены, а страховые пулы заменяют
										ненадёжные ликвидационные аукционы, характерные для DeFi.
									</div>
								</div>

								<div className="numlistUnit">
									<div className="numlistNum">3.</div>
									<div>
										<b>Минимизация рисков</b> &mdash; использование
										диверсифицированных портфелей для защиты займов и торговых
										позиций.
									</div>
								</div>

								<div className="numlistUnit">
									<div className="numlistNum">4.</div>
									<div>
										<b>Справедливая стоимость</b> &mdash; ценообразование,
										основанное на уровне риска. Заемщики могут самостоятельно
										регулировать процентные ставки, изменяя параметры залога.
									</div>
								</div>
							</div>
						</div>
					</div>

					<img src={outstands} alt="" className="about__widepic" />

					<div className="containersm">
						<div className="abouts">
							<h3 className="aboutstitle">
								Решение для&nbsp;пользователей разного уровня
							</h3>
							<div className="about__hatinfo">
								Одной из&nbsp;важных задач было соблюсти баланс и&nbsp;сделать
								страницу, которая&nbsp;бы&nbsp;удовлетворила запросы разных
								сегментов целевой аудитории&nbsp;— от&nbsp;новичков в&nbsp;мире
								криптоинструментов до&nbsp;искушённых пользователей.
								Для&nbsp;новичков акцент сделан на&nbsp;простоте подачи
								и&nbsp;понятных объяснениях. Профессионалам предложен фокус
								на&nbsp;преимуществах и&nbsp;уникальных функциях платформы.
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="feature__wrapper">
				<div className="container">
					<div className="containersm">
						<div className="about__title">
							<h2 className="about__titlerow">
								Исследования, которые мы&nbsp;провели для&nbsp;создания
								эффективной продуктовой страницы Equilibrium
							</h2>
						</div>

						<div className="researchs">
							<h3 className="researchs__subtitle">
								Анализ конкурентов в&nbsp;сети Polkadot и&nbsp;других
								блокчейн-проектах
							</h3>
							<div>
								Мы&nbsp;изучили платформы в&nbsp;сети Polkadot и&nbsp;других
								блокчейн проектах. При&nbsp;этом искали не&nbsp;только сильные
								решения, но&nbsp;и&nbsp;откровенно слабые проекты конкурентов.
								Это&nbsp;позволило выявить лучшие практики, определить слабые
								места и&nbsp;сформулировать гипотезы для&nbsp;улучшения нашей
								страницы. Мы&nbsp;обнаружили основные боли и&nbsp;проблемы
								пользователей и&nbsp;использовали
								их&nbsp;для&nbsp;проектирования продуктовой страницы
								Equilibrium.
							</div>
						</div>

						<div className="researchs">
							<h3 className="researchs__subtitle">
								Визуальный анализ для&nbsp;понимания языка аудитории
							</h3>
							<div>
								Мы&nbsp;изучили, как&nbsp;визуально и&nbsp;текстово оформляют
								свои продукты другие платформы в&nbsp;сфере криптоинструментов.
								Это&nbsp;помогло понять, на&nbsp;каком языке привыкли общаться
								пользователи, и&nbsp;создать дизайн, который будет
								для&nbsp;них&nbsp;понятным и&nbsp;привычным. Такой подход важен
								для&nbsp;формирования доверия, что&nbsp;особенно критично
								для&nbsp;продуктов в&nbsp;сфере криптовалют. Он&nbsp;делает
								взаимодействие с&nbsp;продуктом комфортным
								как&nbsp;для&nbsp;новичков, так&nbsp;и&nbsp;для&nbsp;опытных
								пользователей.
							</div>
						</div>
					</div>

					<img
						src={research}
						alt="Скриншот интерфейса калькулятора стейкинга на платформе"
						className="about__widepic"
					/>
				</div>
			</div>

			<div className="feature__wrapper equi__colored">
				<div className="container">
					<div className="containersm">
						<div className="about__title">
							<div>
								<h2 className="about__titlerow">
									Как&nbsp;исследования повлияли на&nbsp;структуру и&nbsp;дизайн
									продуктовой страницы
								</h2>
								<div className="about__hatinfo hatinfo__hatfix">
									UX-исследования являются основой для&nbsp;создания удобного
									и&nbsp;эффективного дизайна, позволяя глубже понять
									потребности аудитории, их&nbsp;проблемы и&nbsp;ожидания,
									а&nbsp;также найти точки для&nbsp;улучшения пользовательского
									опыта.
								</div>
							</div>
						</div>

						<div className="abouts">
							<h3 className="aboutstitle">
								Проблемы и&nbsp;потребности пользователей
							</h3>
							<div className="about__hatinfo">
								UX-исследования показали, что&nbsp;пользователям не&nbsp;хватает
								единого пространства для&nbsp;выполнения всех функций.
								Всё&nbsp;разбросано по&nbsp;разным платформам&nbsp;— разные
								счета, кошельки, интерфейсы и&nbsp;язык. Из-за&nbsp;этого люди
								тратят много времени, чтобы&nbsp;разобраться в&nbsp;разных
								системах и&nbsp;переводить средства между&nbsp;ними.
								Это&nbsp;неудобно, вызывает разочарование, особенно
								у&nbsp;неопытных пользователей, и&nbsp;снижает интерес
								к&nbsp;платформам. Когда есть&nbsp;выбор, пользователи
								предпочитают более простые и&nbsp;удобные решения.
							</div>
						</div>

						<div className="abouts">
							<h3 className="aboutstitle">
								Как&nbsp;исследования повлияли на&nbsp;дизайн страницы
							</h3>
							<div className="about__hatinfo">
								Мы&nbsp;придумали, как&nbsp;показать пользователям,
								что&nbsp;с&nbsp;помощью Equilibrium можно заработать. Вместо
								текста, как&nbsp;в&nbsp;статьях, мы&nbsp;сделали визуальные
								схемы, чтобы&nbsp;всё&nbsp;было понятно с&nbsp;первого взгляда.
								Иллюстрации, графики и&nbsp;схемы вообще стали важной частью
								страницы, потому что&nbsp;так&nbsp;информация воспринимается
								проще и&nbsp;быстрее. Такой подход снижает порог входа, особенно
								для&nbsp;новичков, и&nbsp;помогает удерживать внимание
								даже&nbsp;у&nbsp;продвинутой аудитории.
							</div>
						</div>
					</div>

					<img src={usecases} alt="" className="about__widepic" />
				</div>
			</div>

			<div className="feature__wrapper gradiented">
				<div className="container">
					<div className="containersm">
						<div className="about__title">
							<h2 className="about__titlerow">
								Как мы создавали структуру и тестировали элементы продуктовой
								страницы
							</h2>
						</div>

						<div className="researchs">
							<h3 className="researchs__subtitle">
								Итеративный подход к&nbsp;дизайну блоков{" "}
							</h3>
							<div>
								Каждый блок страницы, включая ключевые элементы, проходил
								несколько итераций дизайна. Например, для&nbsp;одного только
								блока Earn мы&nbsp;разработали десятки визуальных концепций.
								Каждая версия фокусировалась на&nbsp;удобстве восприятия,
								включая вариации в&nbsp;расположении элементов, цветовых схемах
								и&nbsp;описаниях.
							</div>
						</div>

						<div className="researchs">
							<h3 className="researchs__subtitle">
								А/Б-тестирование страниц и&nbsp;ключевых блоков{" "}
							</h3>
							<div>
								Часть блоков, включая <b>Earn</b>, участвовали в&nbsp;живом
								А/Б-тестировании. Мы&nbsp;проверяли, какие концепции лучше
								привлекают внимание и&nbsp;обеспечивают высокую конверсию.
								Например, проверяли, какой подход лучше привлекает
								внимание&nbsp;— горизонтальные карточки с&nbsp;минималистичным
								дизайном или&nbsp;более информативные блоки
								с&nbsp;детализированными описаниями. Результаты тестирования
								помогли выбрать финальный дизайн, который сочетает в&nbsp;себе
								ясность, визуальную привлекательность и&nbsp;удобство.
								В&nbsp;итоге только те&nbsp;решения, которые демонстрировали
								лучшие результаты, попадали в&nbsp;финальную версию страницы.
							</div>
						</div>
					</div>

					<div className="doutblepics">
						<img
							src={testa}
							alt="А/Б тестирование интерфейса продуктовой страницы"
							className="about__widepic"
						/>
						<img
							src={testb}
							alt="А/Б тестирование интерфейса продуктовой страницы"
							className="about__widepic"
						/>
					</div>

					<div className="containersm">
						<div className="researchs">
							<h3 className="researchs__subtitle">
								Разделение страниц по&nbsp;задачам
							</h3>
							<div>
								Каждая продуктовая подстраница была создана для&nbsp;решения
								конкретной задачи, чтобы&nbsp;пользователям было проще найти
								нужную информацию и&nbsp;начать взаимодействие
								с&nbsp;платформой.
								<br />
								Например, страница про&nbsp;EQ Utility Token рассказывает
								о&nbsp;его&nbsp;функциях: управление платформой, оплата комиссий
								и&nbsp;обеспечение ликвидности. Также&nbsp;добавлены ссылки
								на&nbsp;биржи и&nbsp;кнопка для&nbsp;быстрого старта.
								<br />
								На&nbsp;странице EQ Staking акцент сделан на&nbsp;стейкинге.
								Здесь пользователи могут выбрать срок стейкинга, посмотреть
								график доходности и&nbsp;быстро начать. <br />
								Такой подход делает интерфейс понятным и&nbsp;удобным
								для&nbsp;всех категорий пользователей.
							</div>
						</div>

						<div className="researchs">
							<h3 className="researchs__subtitle">
								Разработка и&nbsp;тестирование калькулятора стейкинга
							</h3>
							<div>
								Для&nbsp;калькулятора стейкинга, который был&nbsp;вынесен
								на&nbsp;отдельную страницу, мы&nbsp;разработали несколько
								концепций. Каждая версия тестировалась на&nbsp;реальных
								пользователях, чтобы&nbsp;выяснить, какой дизайн будет наиболее
								удобным и&nbsp;эффективным.&nbsp;
								<br />
								Мы&nbsp;экспериментировали с&nbsp;подходами: одна версия была
								минималистичной, другая включала больше деталей, таких
								как&nbsp;статистика портфеля и&nbsp;примеры использования eqDOT.
								<br />
								Финальный вариант объединил понятный интерфейс, наглядную
								графику, детали о&nbsp;доходности и&nbsp;визуализацию
								возможностей стейкинга. Все&nbsp;наглядно,
								и&nbsp;в&nbsp;то&nbsp;же&nbsp;время ничего лишнего.
							</div>
						</div>
					</div>
					<img
						src={calcs}
						alt="Прототип продуктовой страницы для криптовалютного проекта"
						className="about__widepic"
					/>
				</div>
			</div>

			<div className="feature__wrapper">
				<div className="container">
					<div className="containersm">
						<div className="about__title">
							<div>
								<h2 className="about__titlerow">
									Визуальные компоненты в дизайне продуктовой страницы
								</h2>

								<div className="about__hatinfo hatinfo__hatfix">
									В проекте мы использовали 3D объекты, чтобы придать дизайну
									глубину и современность. В блоках Swap и Earn 3D графика
									помогла визуализировать ключевые задачи, сделав их более
									понятными и привлекательными для пользователей.
									<br />
									Такие элементы подчёркивают технологичность и инновационный
									подход платформы, что особенно важно в сфере криптовалют, а
									также усиливают визуальное восприятие, делая страницу стильной
									и запоминающейся.
								</div>
							</div>
						</div>
						<img src={visuals} alt="" className="about__widepic" />
					</div>
				</div>
			</div>

			<div
				className="feature__wrapper"
				style={{
					background:
						"linear-gradient(0deg, #F1F5F9 0%, #F1F5F9 100%), linear-gradient(109deg, #429BD6 11.77%, #3F62D5 95.81%)",
				}}
			>
				<div className="container">
					<div className="containersm">
						<div className="about__title">
							<div>
								<h2 className="about__titlerow">Сроки проекта</h2>

								<div className="about__hatinfo hatinfo__hatfix">
									Работа над проектом длилась более 1,5 лет. В течение этого
									времени наши дизайнеры полностью сосредоточились на проекте,
									разрабатывая как главную страницу, так и другие элементы
									продукта, о которых мы расскажем в следующих кейсах.
									<br />
									Мы разрабатывали и тестировали различные концепции, проводили
									А/Б-тестирования и обсуждения внутри команды, чтобы выбрать
									лучшее. Например, одна из первых версий дизайна была
									значительно упрощенной по сравнению с финальной. Постепенно,
									через итерации и тесты, мы добавляли важные элементы и
									улучшали структуру, что позволило достичь нужного баланса
									между задачами бизнеса и удобством для пользователей.
								</div>
							</div>
						</div>
					</div>

					<div className="doutblepics">
						<img
							src={polkadot}
							alt="Визуализация ключевых возможностей платформы Equilibrium"
							className="about__widepic"
						/>
						<img
							src={utility}
							alt="Дизайн страницы с 3D элементами для криптовалютной платформы"
							className="about__widepic"
						/>
					</div>
				</div>
			</div>

			<div className="feature__wrapper equi__colored">
				<div className="container">
					<div className="containersm">
						<div className="about__title">
							<div>
								<h2 className="about__titlerow">Мобильная версия </h2>

								<div className="about__hatinfo hatinfo__hatfix">
									Для проекта была разработана мобильная версия продуктовых
									страниц, так как около 80% трафика приходит с мобильных
									устройств. Это делает стабильную и оптимизированную мобильную
									версию страницы критически важной, поскольку она позволяет
									пользователям легко и комфортно взаимодействовать с продуктом,
									независимо от устройства.
								</div>
							</div>
						</div>

						<img
							src={screens}
							alt="Адаптивный дизайн продуктовой страницы для мобильных устройств"
							className="about__widepic"
						/>
					</div>
				</div>
			</div>

			<div
				className="feature__wrapper"
				style={{
					background:
						"linear-gradient(0deg, #F1F5F9 0%, #F1F5F9 100%), linear-gradient(109deg, #429BD6 11.77%, #3F62D5 95.81%)",
				}}
			>
				<div className="container">
					<div className="containersm">
						<div className="about__title">
							<h2 className="about__titlerow">
								Результаты и ценность продуктовой страницы
							</h2>
						</div>

						<div className="about__hatinfo">
							Созданная продуктовая страница успешно справляется с задачами. Она
							не только информирует пользователей о возможностях платформы
							Equilibrium, но и помогает им с первого взгляда понять, куда они
							попали, и какие преимущества предлагает продукт. Главная цель —
							перевод заинтересованных пользователей в продукт — была успешно
							выполнена. Хотя точные показатели конверсии разглашать мы не
							вправе, они выше среднего по рынку.
						</div>

						<br />
						<div className="about__hatinfo">
							Страница приносит ценность как пользователям, так и клиенту:
						</div>

						<div className="numlist">
							<div className="numlistUnit">
								<div className="numlistNum">1.</div>
								<div>
									<b>Пользователи</b> получают информацию о преимуществах DeFi,
									обучаются через конкретные советы и шаги, а также быстро
									получают доступ к продукту.
								</div>
							</div>

							<div className="numlistUnit">
								<div className="numlistNum">2.</div>
								<div>
									<b>Клиент</b> получил удобный инструмент, который помогает
									привлекать и обучать аудиторию, укрепляя позиции Equilibrium
									на рынке.
								</div>
							</div>
						</div>
						<br />

						<div className="about__hatinfo">
							Все страницы и элементы платформы, были созданы на основе
							разработанной нами дизайн-системы. Единые правила и стандарты
							обеспечили целостность и согласованность всех продуктов
							Equilibrium. Это ускорило процесс разработки, упростило внесение
							изменений и гарантировало качественное пользовательское
							взаимодействие.
						</div>

						<button
							className="action__button"
							onClick={() => {
								navigate(`?modal`);
							}}
						>
							Обсудить проект
						</button>
					</div>
				</div>
			</div>

			<div className="footerwrapper">
				<div className="container">
					<Footer backgroundColor="transparent" />
				</div>
			</div>

			<ContactUsModal />
		</div>
	);
}

export default EquiPage;
